module.exports = __webpack_public_path__ + "img/ESTHER-MARKETING.182373af.jpg";